import { IX3Admin, IRefreshWidgetSignal, ActionEnum, CallStatusEnum, IAdminViewModel, IAPICallResult, IConfirmBoxParams, ICultureInfo, IDispatcher, IErrorMessages, IGenericList, IGetDynListParams, ILoginResult, ILoginViewModel, IMenuTab, IRefreshTokenResult, IRegExpResultModel, ISaveConfigModel, IUploadImgResult, IViewContext, IViewContextParams, IRunX3WSResult, IPoolInfo, IPoolActionResult, IX3AdminViewModel, IPoolMappingEntry, IX3Methods } from "../abstraction";
import { AppLabels } from "../core/AppLabels";
import { KEvent } from "../core/utils";
import { resourceManager, securitySvc, soundSvc } from "../Karma";
import { TechInfosModel } from "../models/TechInfosModel";
import { Apis } from "./api";


export interface IActionParam {
	ActionCode: string;
	Params: any;
}

export class Dispatcher implements IDispatcher, IRefreshWidgetSignal, IX3Methods, IX3Admin {
	constructor() {
		this.apis.OnAPIRequestCompleted.add((data: IAPICallResult<any>) => {
			if (data.action == ActionEnum.PopupAndSOund || data.action == ActionEnum.Sound) {

				if ((data.sound == "") || (data.sound == undefined)) {
					if (data.status >= CallStatusEnum.Error) data.sound = soundSvc.DefautSound_Error;
					if (data.status == CallStatusEnum.Warning) data.sound = soundSvc.DefautSound_Warning;
					if ((data.status == CallStatusEnum.Ok) || (data.status == CallStatusEnum.Default)) data.sound = soundSvc.DefautSound_Ok;
				}

				if ((data.sound != "") && (data.sound != null)) {
					soundSvc.play(data.sound.trim().toUpperCase());
				}
			}

			if (data.action == ActionEnum.Popup || data.action == ActionEnum.PopupAndSOund) {
				if (data.messages.length > 0) {

					let windowType: number = 1;
					let windowTitle = AppLabels.infoTitle;

					switch (data.status) {
						case CallStatusEnum.Ok:
						case CallStatusEnum.Default:
						case CallStatusEnum.Information:
							windowType = 1;
							break;

						case CallStatusEnum.Warning:
							windowType = 2;
							windowTitle = AppLabels.warningTitle;
							break;

						case CallStatusEnum.Error:
						case CallStatusEnum.Critical:
						default:
							windowType = 3;
							windowTitle = AppLabels.errorTitle;
							break;
					}

					var message = [];
					data.messages.map(x => message.push(x.message));

					this.OnShowMessageBox.trigger({ title: windowTitle, messages: message, type: windowType });
				}

			}
		});
	}

	private apis: Apis = new Apis();

	public get RequestCounter(): number { return this.requestCounter };

	private requestCounter: number = 0;

	private _OnRequestEnd: KEvent<any> = new KEvent<any>();
	public get OnRequestEnd(): KEvent<any> { return this._OnRequestEnd; }

	private _OnRequestStart: KEvent<any> = new KEvent<any>();
	public get OnRequestStart(): KEvent<any> { return this._OnRequestStart; }

	private beforeRequest() {
		this.requestCounter++;
		this.OnRequestStart.trigger(this.requestCounter);
	}

	private afterRequest() {
		this.requestCounter--;
		this.OnRequestEnd.trigger(this.requestCounter);
	}

	//#region Configuration

	public async saveConfig(config: ISaveConfigModel): Promise<boolean> {
		return new Promise<boolean>(async (resolve, reject) => {
			this.beforeRequest();
			let result = await this.apis.saveConfig(config);
			this.afterRequest();
			return resolve(result.data);
		});
	}

	//#endregion

	// Charge les différentes ressources nécessaires à l'affichage de la page Login
	public async getLoginRessources(lang: string): Promise<ILoginViewModel> {
		return new Promise<ILoginViewModel>(async (resolve, reject) => {
			this.beforeRequest();
			let result = await this.apis.getLoginResources(lang);
			this.afterRequest()
			return resolve(result.data);
		});
	}

	// Charge le modèle de données de la page d'administration
	public async getAdminViewModel(): Promise<IAdminViewModel> {
		return new Promise<IAdminViewModel>(async (resolve, reject) => {
			console.debug("dispatcher.getAdminViewModel")
			this.beforeRequest();
			let result = await this.apis.getAdminViewModel();
			this.afterRequest();
			return resolve(result.data);
		});
	}

	// Obtient le code de la langue X3 en fontion du code régional passé (issu du navigateur)
	public async getX3LangCode(lang: string): Promise<string> {
		return new Promise<string>(async (resolve, reject) => {
			console.debug("dispatcher.getX3LangCode")

			try {

				this.beforeRequest();
				let result = await this.apis.getX3LangCode(lang);
				this.afterRequest();

				resolve(result.data);
			}
			catch (err: any) {
				console.error(err);
				reject();
			}
		});
	}

	public handleBarCode(barcode: string): void {
		this.OnbarCodeReceived.trigger(barcode);
	}

	private _OnBarCodeReceived: KEvent<string> = new KEvent<string>();
	public get OnbarCodeReceived(): KEvent<string> { return this._OnBarCodeReceived; }

	public async getCultureInfos(): Promise<ICultureInfo[]> {
		return new Promise<ICultureInfo[]>(async (resolve, reject) => {
			console.debug("dispatcher.getCultureInfos")



			this.beforeRequest();
			let result = await this.apis.getCultures();
			this.afterRequest();

			if ((result.status != CallStatusEnum.Ok) && (result.messages.length > 0)) {
				return reject(null)
			}

			return resolve(result.data);
		});
	}

	public async getMenus(menCode: string): Promise<IMenuTab[]> {
		return new Promise<IMenuTab[]>(async (resolve, reject) => {
			try {
				console.debug("dispatcher.getMenus")

				this.beforeRequest();
				let result = await this.apis.getUserMenus(menCode);
				this.afterRequest();

				if (result) {
					if (result.messages) {
						if ((result.messages.length > 0) && (result.status != CallStatusEnum.Ok))
							return reject(null)
					}
					return resolve(result.data);
				}
				return reject(null)
			}
			catch (err) {
				console.log(err);
				return reject(err);
			}
		});
	}

	// Lecture des informations de l'utilisateur (après un restore session)
	public async GetUserInfos(id: string): Promise<ILoginResult> {
		return new Promise<ILoginResult>(async (resolve, reject) => {
			try {
				console.log("dispatcher.GetUserInfos(" + id + ")");

				this.beforeRequest();
				let result = await this.apis.getUserData(id);
				this.afterRequest();
				if (result.status == CallStatusEnum.ServerUnauthorized) return reject();

				return resolve(result.data);
			}
			catch (err) {
				console.log(err);
				return reject(err);
			}
		});
	}

	//#region Message Boxes

	public MessageBox(title: string, message: string, type: number): void {
		let messages: string[] = [];
		messages.push(message);
		this._OnShowMessageBox.trigger({ messages: messages, title: title, type: type })
	}

	private _OnShowMessageBox: KEvent<IErrorMessages> = new KEvent<IErrorMessages>();
	public get OnShowMessageBox(): KEvent<IErrorMessages> { return this._OnShowMessageBox; }

	// La Layout est abonnée à cet évènement et lancera le process d'affichage
	public async ConfirmBox(title: string, message: string, yes: string, no: string, autoclosedelay: number = 0): Promise<boolean> {
		return new Promise<boolean>(async (resolve, reject) => {
			this._OnConfirm.trigger({
				title: title,
				yesText: yes,
				noText: no,
				message: message,
				duration: autoclosedelay,
				closeCallBack: (e) => {
					this.OnCloseConfirm.trigger(null);
					resolve(e);

				}
			});
		});
	}

	private _OnConfirm: KEvent<IConfirmBoxParams> = new KEvent<IConfirmBoxParams>();
	public get OnConfirm(): KEvent<IConfirmBoxParams> { return this._OnConfirm; }

	private _OnCloseConfirm: KEvent<void> = new KEvent<void>();
	public get OnCloseConfirm(): KEvent<void> { return this._OnCloseConfirm; }

	//#endregion

	static idSession: string = "";
	static idtransac: string = "";
	static idSite: string = "";

	public async getViewContext(viewState: IViewContextParams): Promise<IViewContext> {
		return new Promise<IViewContext>(async (resolve, reject) => {
			console.debug("dispatcher.getViewContext");

			if (Dispatcher.idSession == "") Dispatcher.idSession = securitySvc.currentUser.id;
			viewState.idSession = Dispatcher.idSession ?? "";
			viewState.idTransaction = Dispatcher.idtransac ?? "";
			viewState.idSite = Dispatcher.idSite;
			this.beforeRequest();
			let result = await this.apis.getViewContext(viewState);

			if (result.data) {
				Dispatcher.idSession = result.data.IdSession;
				Dispatcher.idtransac = result.data.IdTransaction;
				Dispatcher.idSite = result.data.IdSite;
			}

			this.afterRequest();

			if (result.status >= CallStatusEnum.Error) {
				console.debug(`getViewContext : rejecting (status=${result.status})`)
				return reject(result.messages)
			}

			this.lastViewContext = result.data as IViewContext;

			return resolve(result.data as IViewContext);
		});
	}

	private lastViewContext: IViewContext = null;

	public getLastViewContext(): IViewContext { return this.lastViewContext };

	public async getGenericList(code: string): Promise<IGenericList> {
		return new Promise<IGenericList>(async (resolve, reject) => {
			console.debug("dispatcher.getGenericList")

			this.beforeRequest();
			let result = await this.apis.getGenericList(code);
			this.afterRequest();

			if (result.status != CallStatusEnum.Ok) {
				console.debug(`dispatcher.getGenericList : rejecting (status=${result.status})`)
				return reject(result.messages)
			}
			return resolve(result.data);
		});
	}

	public async getDynamicList(viewstate: IGetDynListParams): Promise<IGenericList> {
		return new Promise<IGenericList>(async (resolve, reject) => {

			console.debug("dispatcher.getDynamicList")

			viewstate.site = Dispatcher.idSite;

			this.beforeRequest();
			let result = await this.apis.getDynamicList(viewstate);
			this.afterRequest();

			if (result.status != CallStatusEnum.Ok) {
				console.debug(`dispatcher.getDynamicList : rejecting (status=${result.status})`);
				return reject(result.messages);
			}
			return resolve(result.data);
		});
	}

	// 

	//#region ILogin implementation

	public async Login(login: string, password: string): Promise<ILoginResult> {
		return new Promise<ILoginResult>(async (resolve, reject) => {
			try {
				console.debug("dispatcher.Login");

				this.beforeRequest();
				let result = await this.apis.postLogin(login, password);
				this.afterRequest();

				return resolve(result.data);
			}
			catch (err) {
				this.afterRequest();
				return reject(err)
			}
		});
	}

	// Il est possible que cette magnifique fonctionnalité soit utilisée pour déconnecter l'utilisateur
	// 
	public async Logout(notrace: boolean = false): Promise<boolean> {
		return new Promise<boolean>(async (resolve, reject) => {
			try {
				console.debug("dispatcher.Logout");
				this.beforeRequest();
				await this.apis.logOut(notrace);
				this.afterRequest();

				return resolve(true);
			}
			catch (err) {
				console.debug("dispatcher.Logout exception : ");
				console.debug(err);
				this.afterRequest();
				return reject(false)
			}
		});
	}

	// Le token a trop chaud ou est sur le point d'expirer, il faut le rafraichir
	public async RefreshAuthToken(): Promise<IRefreshTokenResult> {
		return new Promise<IRefreshTokenResult>(async (resolve, reject) => {
			console.debug("dispatcher.RefreshAuthToken")

			this.beforeRequest();
			let result = await this.apis.refreshToken();
			this.afterRequest();

			if (result.status != CallStatusEnum.ServerHTTPOK) {
				return reject(null)
			}

			return resolve(result.data);
		});
	}

	// LE token est sur le point d'expirer, on prévient l'utilisateur
	// La vue est abonnée (en principe) à l'évènement OnTokenEOLReached pour déclencher un affichage d'alerte
	public TokenWillExpire() {
		if (securitySvc.isAuth) {
			this.OnTokenEOLReached.trigger(null);
		}
	}

	private _OnTokenEOLReached: KEvent<any> = new KEvent<any>();
	public get OnTokenEOLReached(): KEvent<any> { return this._OnTokenEOLReached; }


	// La session est sur le point d'expirer, on prévient l'utilisateur
	// La vue est abonnée (en principe) à l'évènement OnSessionEnding pour déclencher un affichage d'alerte
	public SessionWillExpire() {
		if (securitySvc.isAuth) {
			this.OnSessionEnding.trigger(null);
		}
	}

	private _OnSessionEnding: KEvent<any> = new KEvent<any>();
	public get OnSessionEnding(): KEvent<any> { return this._OnSessionEnding; }

	//#endregion

	private _techInfosModel: TechInfosModel = new TechInfosModel();
	public get techInfosModel(): TechInfosModel { return this._techInfosModel; }

	// Evènement permettant aux composants de diffuser un évènement générique aux autres abonnés
	private _OnGenericAction: KEvent<IActionParam> = new KEvent<IActionParam>();
	public get OnGenericAction(): KEvent<IActionParam> { return this._OnGenericAction; }


	//#region IVirtual Keyboard Implementation

	// Evènement indiquant que la mode de saisie au clavier virtual a changé
	private _onVirtualKeyboardChanged: KEvent<boolean> = new KEvent<boolean>();
	public get onVirtualKeyboardChanged(): KEvent<boolean> { return this._onVirtualKeyboardChanged; }

	private _isVirtualKeyboardActive = false;

	public get isVirtualKeyboardActive(): boolean {
		{ return this._isVirtualKeyboardActive; }
	}
	public set isVirtualKeyboardActive(value: boolean) {
		{
			this._isVirtualKeyboardActive = value;
			this._onVirtualKeyboardChanged.trigger(value);
		}
	}

	//#endregion 

	//#region ILogReader Implementation

	public async getLogList(): Promise<string[]> {
		return new Promise<string[]>(async (resolve, reject) => {
			console.debug("dispatcher.getLogList")

			this.beforeRequest();
			let result = await this.apis.getLogList();
			this.afterRequest();

			if (result.status != CallStatusEnum.Ok) {
				console.debug(`dispatcher.getLogList : rejecting (status=${result.status})`)
				return reject(result.messages)
			}
			return resolve(result.data);
		});
	}

	public async getLogFile(file: string): Promise<string[]> {
		return new Promise<string[]>(async (resolve, reject) => {
			console.debug("dispatcher.getLogFile")

			this.beforeRequest();
			let result = await this.apis.getLogFile(file);
			this.afterRequest();

			if (result.status != CallStatusEnum.Ok) {
				console.debug(`dispatcher.getLogFile : rejecting (status=${result.status})`)
				return reject(result.messages)
			}
			return resolve(result.data);
		});
	}

	//#endregion

	// Parse une expression régulière
	// - On passe aujourd'hui par une API
	// - Lorsque les navigateurs prendront tous en charge la gestion des groupes nommés, le traitement pourra être fait en local
	public async regParser(expression: string, value: string): Promise<IRegExpResultModel> {
		return new Promise<IRegExpResultModel>(async (resolve, reject) => {
			console.debug("dispatcher.regParser")

			this.beforeRequest();
			let result = await this.apis.regParser(expression, value);
			this.afterRequest();

			if (result.status != CallStatusEnum.Ok) {
				console.debug(`dispatcher.regParser : rejecting (status=${result.status})`)
				return reject(result.messages)
			}
			return resolve(result.data);
		});
	}

	//#region IImageProvider implementation

	// Retourne l'image (icone) correspondant au code passé
	public getImg = (code: string) => {
		return resourceManager.getImg(code);
	}

	// Permet d'uploader une image vers le serveur
	public async uploadImg(data: string): Promise<IUploadImgResult> {
		return new Promise<IUploadImgResult>(async (resolve, reject) => {
			console.debug("dispatcher.uploadImg")

			this.beforeRequest();
			let result = await this.apis.uploadImg(data);
			this.afterRequest();

			if (result.status != CallStatusEnum.Ok) {
				console.debug(`dispatcher.uploadImg : rejecting (status=${result.status})`)
				return reject(result.messages)
			}

			return resolve(result.data);
		});
	}

	//#endregion

	//#region IX3Methods implementation

	// Permet d'appeler un Web service manuellement
	//
	public async runX3WS(wsName: string, wsParams: string, wsPool: string): Promise<IRunX3WSResult> {
		return new Promise<IRunX3WSResult>(async (resolve, reject) => {
			console.debug("dispatcher.runX3WS")

			this.beforeRequest();
			let result = await this.apis.runX3WS(wsName, wsParams, wsPool);
			this.afterRequest();

			if (result.status != CallStatusEnum.Ok) {
				console.debug(`dispatcher.runX3WS : rejecting (status=${result.status})`)
				return reject(result.messages)
			}

			return resolve(result.data);
		});
	}

	// Permet d'obtenir la liste des pools X3 disponibles
	//
	public async getPoolList(): Promise<IPoolInfo[]> {
		return new Promise<IPoolInfo[]>(async (resolve, reject) => {
			console.debug("dispatcher.getPoolList")

			this.beforeRequest();
			let result = await this.apis.getPoolList();
			this.afterRequest();

			if (result.status != CallStatusEnum.Ok) {
				console.debug(`dispatcher.getPoolList : rejecting (status=${result.status})`)
				return reject(result.messages)
			}

			return resolve(result.data);
		});
	}

	// Démarre le pool spécifié
	//
	public async startPool(poolId: string): Promise<IPoolActionResult> {
		return new Promise<IPoolActionResult>(async (resolve, reject) => {
			console.debug("dispatcher.startPool")

			this.beforeRequest();
			let result = await this.apis.startPool(poolId);
			this.afterRequest();

			if (result.status != CallStatusEnum.Ok) {
				console.debug(`dispatcher.startPool : rejecting (status=${result.status})`)
				return reject(result.messages)
			}

			return resolve(result.data);
		});
	}

	// Stop le pool spécifié
	//
	public async stopPool(poolId: string): Promise<IPoolActionResult> {
		return new Promise<IPoolActionResult>(async (resolve, reject) => {
			console.debug("dispatcher.stopPool")

			this.beforeRequest();
			let result = await this.apis.stopPool(poolId);
			this.afterRequest();

			if (result.status != CallStatusEnum.Ok) {
				console.debug(`dispatcher.stopPool : rejecting (status=${result.status})`)
				return reject(result.messages)
			}

			return resolve(result.data);
		});
	}

	//#endregion IX3Methods implementation

	//#region IX3Admin implementation
	//  
	public async savePoolConfig(mapping: IPoolMappingEntry[], pools: string[]): Promise<boolean> {
		return new Promise<boolean>(async (resolve, reject) => {
			console.debug("dispatcher.saveMapping")

			this.beforeRequest();
			let result = await this.apis.savePoolConfig(mapping, pools);
			this.afterRequest();

			if (result.status != CallStatusEnum.Ok) {
				console.debug(`dispatcher.saveMapping : rejecting (status=${result.status})`)
				return reject(result.messages)
			}

			return resolve(result.data);
		});
	}

	public async getX3AdminViewModel(): Promise<IX3AdminViewModel> {
		return new Promise<IX3AdminViewModel>(async (resolve, reject) => {
			console.debug("dispatcher.getX3AdminViewModel")

			this.beforeRequest();
			let result = await this.apis.getX3AdminViewModel();
			this.afterRequest();

			if (result.status != CallStatusEnum.Ok) {
				console.debug(`dispatcher.getX3AdminViewModel : rejecting (status=${result.status})`)
				return reject(result.messages)
			}

			return resolve(result.data);
		});
	}

	//#endregion IX3Methods implementation

	// Evènement dédié au rafraîchissement des widgets de portail
	private _OnRefreshWidget: KEvent<string> = new KEvent<string>();
	public get OnRefreshWidget(): KEvent<string> { return this._OnRefreshWidget; }

	//#region IRefreshWidgetSignal implementation

	public SendRefresh = (target: string) => {
		this.OnRefreshWidget.trigger(target)
	}

	//#endregion

}

